import type { JSX } from 'react';

import { Box, Container } from '@change-corgi/design-system/layout';

import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from 'src/app/app/layout';
import { useFocusFallbackRef } from 'src/app/shared/hooks/focus';
import { LOGIN_OR_SIGNUP_WIDTH } from 'src/app/shared/utils/loginOrJoin';

import { LoginOrSignupBanner } from '../components/LoginOrSignupBanner';
import { LoginOrSignupBody } from '../components/LoginOrSignupBody';
import { LoginOrSignupFooter } from '../components/LoginOrSignupFooter';
import { LoginOrSignupHeader } from '../components/LoginOrSignupHeader';

import { useTrackLoginOrSingupPageView } from './hooks/useTrackLoginOrSingupPageView';

export function LoginOrSignupLayout(): JSX.Element {
	useTrackLoginOrSingupPageView();

	const ref = useFocusFallbackRef();

	return (
		<>
			<LoginOrSignupBanner />
			<Box ref={ref}>
				<Container
					variant="small"
					sx={{
						width: ['100%', LOGIN_OR_SIGNUP_WIDTH],
						// setting a min height so that the focus outline looks a bit better when navigating
						minHeight: [`calc(100vh - ${HEADER_HEIGHT_MOBILE}px)`, `calc(100vh - ${HEADER_HEIGHT}px)`],
					}}
				>
					<LoginOrSignupHeader />
					<Box my={32}>
						<LoginOrSignupBody />
					</Box>
					<LoginOrSignupFooter />
				</Container>
			</Box>
		</>
	);
}
